export const leaveRequest = {
  title: "New Leave Request",
  add_leave: "+ Add a leave",
  save_request: "Save request",
  leave_type: "Leave type",
  leave_types: {
    CP: "Paid Leave",
    RTT: "RTT",
    Maladie: "Sick Leave",
    NonPaye: "Unpaid Leave",
  },
  description: "Description",
  actions: {
    add: "Add",
    cancel: "Cancel",
    edit: "✏️",
    delete: "🗑",
  },
  justification: "Supporting document",
  comment: "Comment",
  email_sent_success: "✅ Leave request email sent successfully!",
  email_sent_error: "❌ Failed to send leave request email",
};
